module.exports = __webpack_public_path__ + "media/assets/images/icons/footer-icon-contact-hover-58453d4c31b6edec53763fbea657a686.png";